import React from "react";
import styled from "styled-components";

const Section = styled.section`
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    overflow: hidden;
`;

const Head = styled.div`
    padding: 16px 22px;
    border-bottom: 1px solid #f1f5f9;
`;

const Title = styled.h2`
    margin: 0;
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    font-family: "Inter", system-ui, sans-serif;
`;

const Description = styled.p`
    margin: 4px 0 0;
    font-size: 0.8rem;
    color: #64748b;
    font-family: "Inter", system-ui, sans-serif;
`;

const Body = styled.div`
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

// A section whose blocks name themselves needs no label of its own, and then it carries no head.
export const FormSection = ({ label, description, children }) => (
    <Section>
        {label && (
            <Head>
                <Title>{label}</Title>
                {description && <Description>{description}</Description>}
            </Head>
        )}
        <Body>{children}</Body>
    </Section>
);
